import {
	Directive,
	ElementRef,
	EventEmitter,
	HostListener,
	Input,
	Output,
	OnChanges,
	SimpleChanges,
} from '@angular/core';

@Directive({
	selector: 'input[type=datetime-local][appUtcModel]',
	standalone: true,
})
export class UtcDatetimeDirective implements OnChanges {
	@Input() appUtcModel: string | null = null;
	@Output() appUtcModelChange = new EventEmitter<string | null>();

	constructor(private readonly el: ElementRef<HTMLInputElement>) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['appUtcModel']) {
			this.writeValue(this.appUtcModel);
		}
	}

	@HostListener('input', ['$event.target.value'])
	onInput(localValue: string): void {
		if (!localValue) {
			this.appUtcModelChange.emit(null);
			return;
		}
		const d = new Date(localValue);
		if (isNaN(d.getTime())) {
			this.appUtcModelChange.emit(null);
			return;
		}
		this.appUtcModelChange.emit(d.toISOString().replace(/\.\d{3}Z$/, 'Z'));
	}

	private writeValue(utcIso: string | null): void {
		if (!utcIso) {
			this.el.nativeElement.value = '';
			return;
		}
		const d = new Date(utcIso);
		if (isNaN(d.getTime())) {
			this.el.nativeElement.value = '';
			return;
		}
		const year = d.getFullYear();
		const month = String(d.getMonth() + 1).padStart(2, '0');
		const day = String(d.getDate()).padStart(2, '0');
		const hours = String(d.getHours()).padStart(2, '0');
		const minutes = String(d.getMinutes()).padStart(2, '0');
		this.el.nativeElement.value = `${year}-${month}-${day}T${hours}:${minutes}`;
	}
}
